import { HiMiniStar } from 'react-icons/hi2'

export function EvaluationsStars({ stars, onClick, criteriaId }) {
	return (
		<div className='tw-rounded-xl tw-flex tw-gap-2 tw-text-gray-500 tw-items-center tw-justify-between tw-p-2 tw-px-3'>
			<span>Insuficiente</span>
			<HiMiniStar
				className={`${stars < 1 ? 'tw-text-gray-200' : 'tw-text-alert-300'} ${onClick ? 'tw-cursor-pointer' : ''}`}
				onClick={() => {
					onClick({ dataset: 1, criteriaId: criteriaId })
				}}
			/>
			<HiMiniStar
				className={`${stars < 2 ? 'tw-text-gray-200' : 'tw-text-alert-300'} ${onClick ? 'tw-cursor-pointer' : ''}`}
				onClick={() => {
					onClick({ dataset: 2, criteriaId: criteriaId })
				}}
			/>
			<HiMiniStar
				className={`${stars < 3 ? 'tw-text-gray-200' : 'tw-text-alert-300'} ${onClick ? 'tw-cursor-pointer' : ''}`}
				onClick={() => {
					onClick({ dataset: 3, criteriaId: criteriaId })
				}}
			/>
			<HiMiniStar
				className={`${stars < 4 ? 'tw-text-gray-200' : 'tw-text-alert-300'} ${onClick ? 'tw-cursor-pointer' : ''}`}
				onClick={() => {
					onClick({ dataset: 4, criteriaId: criteriaId })
				}}
			/>
			<HiMiniStar
				className={`${stars !== 5 ? 'tw-text-gray-200' : 'tw-text-alert-300'} ${onClick ? 'tw-cursor-pointer' : ''}`}
				onClick={() => {
					onClick({ dataset: 5, criteriaId: criteriaId })
				}}
			/>
			<span>Muito Bom</span>
		</div>
	)
}
